import {Space} from "antd";
import {ServiceSubPricingCostFormField} from "./cost";

export function ServiceSubPricingFormFields() {
  return (
    <div>
      <Space size={16} direction="vertical" style={{display: "flex"}}>
        <ServiceSubPricingCostFormField />
      </Space>
    </div>
  );
}
